"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = warning;

function printWarning(format) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var index = 0;
  var message = format.replace(/%s/g, function () {
    var arg = args[index];
    index += 1;
    return arg;
  });
  message = "Warning: ".concat(message);

  if (typeof console !== 'undefined') {
    console.error(message);
  }

  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console, it would pause the execution
    // at this line.
    throw new Error(message);
  } catch (error) {// Intentionally blank
  }
}

function warning(condition, format) {
  if (process.env.NODE_ENV !== 'production') {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(void 0, [format].concat(args));
    }
  }
}